module.exports = __webpack_public_path__ + "img/panessex-logo.3b1df390.png";